const suffixes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

export const getBytes = (bytes: number): string => {
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    if (isNaN(i) || i < 0) return "0 Bytes";
    return (bytes / Math.pow(1024, i)).toFixed(2) + " " + suffixes[i];
};
